import { useState } from "react";
import {
    useTiptapEditor,
    FormatButtons,
    AlignmentButtons,
    ListButtons,
    LevelSelect,
    LinkButtons,
    ImageButtons,
    QuoteButtons,
    ColorButtons,
    ClearButtons,
} from "ra-input-rich-text";
import { Button, Menu, MenuItem, ToggleButtonGroup } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import { useTranslate } from "react-admin";

export const RichtextInputActionBar = ({ mediaImages = [] }) => {
    const editor = useTiptapEditor();
    const translate = useTranslate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const insertMedia = (media) => {
        if (editor) {
            const imageUrl = media._links?.download;
            if (imageUrl) {
                editor.chain().focus().setImage({ src: imageUrl, alt: media.shortname }).run();
            }
        }
        handleClose();
    };

    return (
        <ToggleButtonGroup
            sx={{
                flexWrap: "wrap",
                gap: 0.5,
            }}
        >
            <LevelSelect />
            <FormatButtons />
            <AlignmentButtons />
            <ListButtons />
            <LinkButtons />
            <ImageButtons />
            <QuoteButtons />
            <ColorButtons />
            <ClearButtons />

            {mediaImages.length > 0 && (
                <>
                    <Button
                        size="small"
                        onClick={handleClick}
                        startIcon={<ImageIcon />}
                        sx={{
                            minWidth: "auto",
                            px: 1,
                            textTransform: "none",
                        }}
                    >
                        {translate("equip.media")}
                    </Button>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        slotProps={{
                            paper: {
                                maxHeight: 300,
                                width: "250px",
                            },
                        }}
                    >
                        {mediaImages.map((media) => {
                            const imageUrl = media._links?.download;
                            return (
                                <MenuItem
                                    key={media.id}
                                    onClick={() => insertMedia(media)}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        py: 1,
                                    }}
                                >
                                    {imageUrl && (
                                        <img
                                            src={imageUrl}
                                            alt={media.shortname}
                                            style={{
                                                maxWidth: "200px",
                                                maxHeight: "100px",
                                                objectFit: "contain",
                                                marginBottom: "4px",
                                            }}
                                        />
                                    )}
                                    <span style={{ fontSize: "0.875rem" }}>{media.shortname}</span>
                                </MenuItem>
                            );
                        })}
                    </Menu>
                </>
            )}
        </ToggleButtonGroup>
    );
};
